import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security"
import { Navigate } from "react-router-dom";

import AlertTypesMain from "Modules/alertTypes/views/main";

const AlertTypesView = () => {
    const user = useSelector(state => state.securityRedux.user);
    
    return (
        <>
            <Routes>
                {HasPermission(user, "alrttp") && <Route path="list" element={<AlertTypesMain />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default AlertTypesView